import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Layout minimal pour les routes avec préfixe pays (:country).
 * Simple wrapper avec outlet pour appliquer le CountryGuard.
 */
@Component({
  selector: 'app-country-layout',
  standalone: true,
  imports: [RouterOutlet],
  template: ` <router-outlet></router-outlet> `,
})
export class CountryLayoutComponent {}
